import { Alert, Button, Card, CardContent, CardActions, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { Helmet } from 'react-helmet';

import { useEffect, useState } from 'react';
import { AboutUs, useAboutUs } from 'api/aboutUs';

import { useLanguage } from '../../context/LanguageContext'

import { Box, CustomBox, Title, useScreenSize } from 'common';

export const AboutUsPage = () => {
    const { language } = useLanguage();

    const [aboutUs, setAboutUs] = useState<AboutUs[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const { onGetAllAboutUs } = useAboutUs();

    const { isDesktopSize } = useScreenSize();

    const titles = {
        ru: 'О нас',
        en: 'About Us',
        kz: 'Біз туралы'
    };

    const pageTitles = {
        ru: 'О нас - AlmaU Open Library',
        en: 'About Us - AlmaU Open Library',
        kz: 'Біз туралы - AlmaU Open Library'
    };

    const metaDescriptions = {
        ru: 'Информация о библиотеке AlmaU Open Library',
        en: 'Information about AlmaU Open Library',
        kz: 'AlmaU Open кітапханасы туралы ақпарат'
    };

    const buttonLabels = {
        eventPlan: {
            ru: 'План мероприятий',
            en: 'Event Plan',
            kz: 'Іс-шара жоспары'
        },
        rules: {
            ru: 'Правила',
            en: 'Rules',
            kz: 'Ережелер'
        },
        booksAndFilms: {
            ru: 'Список книг и фильмов на сезон 2026–2027',
            en: 'Book and film list for the 2026–2027 season',
            kz: '2026–2027 маусымына арналған кітаптар мен фильмдер тізімі'
        }
    };

    const title = titles[language];
    const pageTitle = pageTitles[language];
    const metaDescription = metaDescriptions[language];
    const eventPlanLabel = buttonLabels.eventPlan[language];
    const rulesLabel = buttonLabels.rules[language]
    const booksAndFilmsLabel = buttonLabels.booksAndFilms[language];

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllAboutUs();
                if (result.success) {
                    setAboutUs(result.data)
                } else {
                    setError('Произошла ошибка при загрузке страницы');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllAboutUs]);

    return (
        <CustomBox title={title}>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : (
                <Box >
                    {aboutUs.map((item) => (
                        <Box key={item.id}>
                            <Card>
                                <Box sx={{ width: '100%', textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
                                    <Title
                                        variant={isDesktopSize ? 'h3' : 'h4'}
                                        sx={{ fontWeight: 900, color: '#af0000 ' }}
                                    >
                                        AlmaU Open Library
                                    </Title>
                                </Box>
                                <CardContent sx={{ marginTop: 2, marginBottom: 2 }}>
                                    <Typography variant="body2" color="text.secondary">
                                        <div dangerouslySetInnerHTML={{
                                            __html: language === 'en' ? item.description_en :
                                                language === 'ru' ? item.description_ru :
                                                    item.description_kz
                                        }} />
                                    </Typography>
                                </CardContent>
                                <Box sx={{ width: '100%', mt: 4, textAlign: 'center' }}>
                                    <iframe
                                        src="https://www.youtube.com/embed/0IFHCcOMGrI?start=1"
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        style={{ width: '60%', height: '500px', borderRadius: '4px' }}>
                                    </iframe>
                                </Box>
                                <CardActions disableSpacing sx={{ margin: '30px 0 0', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
                                    <Button size="large" href={item.plan} target="_blank" variant="outlined" color="error">
                                        {eventPlanLabel}
                                    </Button>
                                    <Button size="large" href={item.rule} target="_blank" variant="outlined" color="error">
                                        {rulesLabel}
                                    </Button>
                                    <Button
                                        size="large"
                                        href="https://almauedu-my.sharepoint.com/:f:/g/personal/lib_almau_edu_kz/IgAoLcv3Axl6RL-e-CmIRORMAdnJHQMwPW6AQ-c5QB5J_CM?e=azy93d"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        variant="outlined"
                                        color="error"
                                    >
                                        {booksAndFilmsLabel}
                                    </Button>
                                </CardActions>
                            </Card>
                        </Box>
                    ))}
                </Box>
            )}
        </CustomBox>
    )
}
